module.exports = __webpack_public_path__ + "media/images/icon-map-blue-540712539c0446e537561b64aadf21f6.svg";